import { h } from '@atomify/jsx';
import { MapTheme, MapThemeExtension } from '@bpd-library/types';

export const extendMapTheme = (...mapThemes: (MapTheme | MapThemeExtension)[]): MapTheme => {
    const newTheme: MapTheme = {
        polygon: { settings: [] },
        pointer: { settings: [], cluster: (total) => <span>{total}</span> },
    };

    mapThemes.forEach(({ polygon, pointer }) => {
        polygon?.settings.length && newTheme.polygon?.settings?.push(...polygon.settings);
        pointer?.settings.length && newTheme.pointer?.settings?.push(...pointer.settings);
        if (pointer?.cluster && newTheme.pointer) {
            newTheme.pointer.cluster = pointer.cluster;
        }
    });

    return newTheme;
};

export const overrideMapTheme = (original: MapTheme, override: MapTheme | MapThemeExtension) => {
    const { polygon: originalPolygon, pointer: originalPointer } = original;
    const { polygon: overridePolygon, pointer: overridePointer } = override;
    const newTheme: MapTheme = {};

    if (originalPolygon?.settings.length) {
        if (!overridePolygon?.settings.length) newTheme.polygon = originalPolygon;
        else {
            newTheme.polygon = {
                settings: originalPolygon.settings.map((setting) => {
                    return (
                        overridePolygon.settings.find(
                            ({ variant }) => variant === setting.variant,
                        ) || setting
                    );
                }),
            };
        }
    }

    if (originalPointer?.settings.length) {
        if (!overridePointer?.settings.length) newTheme.pointer = originalPointer;
        else {
            newTheme.pointer = {
                settings: originalPointer.settings.map((setting) => {
                    return (
                        overridePointer.settings.find(
                            ({ variant }) => variant === setting.variant,
                        ) || setting
                    );
                }),
                cluster: overridePointer.cluster || originalPointer.cluster,
            };
        }
    }

    return newTheme;
};
